import { SelfDrivingService } from "../../server/api/self-driving";
import { toSlug } from "../../utils/create-slug";
import type { AccountContext } from "../generic/hooks/use-account-context";

export async function getToneText(
  tone: "professional" | "casual" | "direct" | "custom",
  toneSummary: string,
  {
    format,
    description,
    fileId,
    salutation,
    signOff,
    context,
  }: {
    format: string;
    description: string;
    fileId?: string;
    salutation?: string;
    signOff?: string;
    context?: AccountContext;
  },
  token: string,
): Promise<{ data: { text: string }; error: null } | { data: null; error: Error }> {
  const service = new SelfDrivingService(token);
  const formatId = toSlug(format).replace(/-/g, "_");
  const response = await service.text(formatId, {
    description,
    tone,
    toneSummary,
    salutation,
    signOff,
    fileId,
    context: {
      companyName: context?.companyName ?? undefined,
      industry: context?.industry ?? undefined,
      companyDescription: context?.companyDescription ?? undefined,
      companyValues: context?.companyValues ?? undefined,
      companyTeamReference: context?.companyTeamReference ?? undefined,
    },
  });

  if (response?.error || !response.data) {
    return { data: null, error: new Error(response.error) };
  }

  return { data: response.data, error: null };
}
